import { getEmailTemplateInfo } from "@app/store/email";
import useSelectorWithArgs from "@app/util/redux/useSelectorWithArgs";

const useEmailTemplateInfoGetter = () => {
  return useSelectorWithArgs(getEmailTemplateInfo);
};

export default useEmailTemplateInfoGetter;
